import React, { FC } from 'react';
import { Paper, Typography } from '@mui/material';

export const NoDisciplineData: FC = () => {
    return (
        <Paper
            sx={{
                p: 4,
                marginTop: 3,
                marginBottom: 3,
                borderRadius: 2,
                boxShadow: 3,
                textAlign: 'center',
                backgroundColor: 'error.lighter', // subtle MUI error background
                color: 'error.main',
                width: '100%',
            }}
        >
            <Typography variant="h4" fontWeight={700} gutterBottom>
                Discipline data not found
            </Typography>
            <Typography variant="body1" color="text.secondary">
                The discipline you are looking for could not be loaded. Please check back later or go a different
                discipline.
            </Typography>
        </Paper>
    );
};
